import {type DiscoveryNode} from './index.ts';
import {type Address} from '../cluster/Address.ts';

export class SimpleDiscoveryNode implements DiscoveryNode {
    readonly privateAddress: Address;
    readonly publicAddress: Address;
    readonly properties: ReadonlyMap<string, unknown>;
    constructor(privateAddress: Address, publicAddress?: Address, properties?: ReadonlyMap<string, unknown>)
    {
        this.privateAddress = privateAddress;
        this.publicAddress = publicAddress ?? privateAddress;
        this.properties = properties ?? new Map();
    }
}
